import React from 'react';
import { IconProps } from '../types/types';

const CTSI: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.9 50"  xmlSpace="preserve" role="img" {...props}><circle cx="25" cy="25.1" r="24.8"/><path d="m45.9 31.4-5-13.6c-.1-.4-.5-.8-1-.8H32L27.1 4.3c-.1-.3-.4-.7-.7-.7-.3-.1-.8.1-1 .3L13.3 17.2H5c-.3 0-.6.2-.9.4-.2.3-.2.6-.1 1l5 13.6c.1.4.5.8 1 .8h7.8l4.8 12.8c.1.3.4.6.8.6h.2c.3 0 .5-.1.8-.3l7.2-7.8 4.8-5.4h8.4c.3 0 .6-.2.9-.4.3-.4.4-.7.2-1.1zM25.7 6.6l4.2 11.2-4.5 5-1.8-5c-.1-.4-.5-.8-1-.8h-6.2l9.3-10.4zM6.5 19.3h15.2l2 5.4-5.5 6h-7.4L6.5 19.3zm23.8 17.4-6 6.5L20.1 32l4.6-5 1.9 5.2c.1.4.5.8 1 .8h6.1l-3.4 3.7zm-2-6-2-5.6 5.4-5.8h7.6l4.3 11.4H28.3z" style={{fill: '#fff'}}/></svg>
);

export default CTSI;
